import React, { useState, useEffect } from 'react';

import { Dialog, Card, Collapse } from '@mui/material';
import { images, icons, markers } from "../../helpers/constants";
import { Trans, useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import SafetyZoneMap from '../Map/SafetyZoneMap';
import { downloadPDF, fixDate } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';


const ExportDataModal = ({show, onClose, info, device, type, onSave, download}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [centralName, setCentralName] = useState()
    const [errorText, setErrorText] = useState()

    const [startDate, setStartDate] = useState(dayjs().subtract(1, 'day'))
    const [endDate, setEndDate] = useState(dayjs())


    const [selectedType, setSelectedType] = useState(-1)
    const [selectedFormat, setSelectedFormat] = useState(null)


    const handleClose = () => {
        onClose()
        setTimeout(() => {
            setSelectedType(-1)

        }, 200);
      //  setShow(false)
    }

    const handleSave = (type) => {        
        if(!selectedFormat){
            toast.error(t("toast.no_format_export"))
            return
        }
        if(!selectedType){
            toast.error(t("toast.no_type_export"))
            return
        }
    
        let data = {}
        let reset = false
        data.deviceid = device?.id
        data.starttime = startDate.toDate()
        data.stoptime = endDate.toDate()
       //data.starttime = "2025-01-07 10:05:20"
       //data.stoptime = "2025-01-11 13:01:58"
        data.format = selectedFormat
        data.type = selectedType

        onSave(data, reset)
    }


    const handleChange = (type, e) => {
        switch(type){
            case "info":
                setCentralName(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }
    
    const generateContent = () => {
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={icons.download} alt=""/>
                    <h3 className="ms-2">{t("settings.export_data")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
            <div className="p-3">
                <p className="dark-grey text-center pb-3">{t("settings.export_data_sub")}</p>
                <div className="d-flex justify-content-betwen">
                    <select onChange={(event) => setSelectedType(event.target.value)} value={selectedType} className="form-control bg-light-grey">
                        <option value="-1">{t("settings.select")}</option>
                        {Object.entries(info?.exporttypes || {})
                            .filter(([_, value]) => value.allowed)
                            .map(([key]) => (
                            <option key={key} value={key}>
                                {t(`settings.${key}`)}
                            </option>
                        ))}
                    </select>
                    {/* <Button onClick={() => downloadCentralData(selectedAlarmCentral)} icon={icons.download} notext={true} btnClass="btn-transparent bg-dark-grey ms-3" /> */}
                </div>
                <div className={`mt-3 ${selectedType === -1 || selectedType === "-1" ? "d-none" : ""}`}>
                    <p className="dark-grey bold mt-3">{t("settings.select_date")}</p>
                    <div className="d-flex justify-content-start m-0 p-0">
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
                            <DateTimePicker
                            ampm={false}
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            maxDate={endDate}
                            className="date_label me-1"
                            />
                        </LocalizationProvider>
                        <p className="m-0 p-0 align-self-center">{t("settings.to")}</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
                            <DateTimePicker
                            ampm={false}
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate}
                            className="date_label ms-1"
                            />
                        </LocalizationProvider>
                    </div>
                    <p className="dark-grey bold mt-3">{t("settings.select_format")}</p>
                    <div className="d-flex justify-content-betwen">
                        <select
                            onChange={(event) => setSelectedFormat(event.target.value)}
                            value={selectedFormat ?? -1}
                            className="form-control bg-light-grey"
                        >
                            <option value="-1">{t("settings.select")}</option>
                            {(info?.exporttypes?.[selectedType]?.formats || []).map((format) => (
                            <option key={format} value={format}>
                                {format}
                            </option>
                            ))}
                        </select>
                        {/* <Button onClick={() => downloadCentralData(selectedAlarmCentral)} icon={icons.download} notext={true} btnClass="btn-transparent bg-dark-grey ms-3" /> */}
                    </div>
                </div>
            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
               <Button onClick={() => handleSave("")} btnClass="btn-primary">{t("settings.confirm")}</Button>
            </div>
            </>
        )
    }

    const downloadContent = () => {
        const data = type.content
        let icon;
        switch(data.type){
            case "positions":
                icon = icons.sidebar.history_active
                break;
            case "temp_humidity":
                icon = icons.temperature
                break;
            case "battery":
                icon = icons.battery_full
                break;
            case "externalvoltage":
                icon = icons.ignition
                break;
            default: icon = icons.sidebar.history_active
        }
        return (
            <>
            <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                <div className='d-flex align-items-center'>
                    <img src={icons.download} alt=""/>
                    <h3 className="ms-2">{t("settings.download_data")}</h3>
                </div>
                <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
            </div>
            <div className="p-3">
                <p className="dark-grey text-center pb-3">{t("settings.download_data_sub")}</p>
                <div className="p-3 grey-bg border-sm position-relative">
                    <img src={icon} className="size_25 position-absolute top-0 end-0 mt-2 me-2" alt=""/>
                    <h4 className="m-0 p-0">{t(`settings.${data.type}`)}</h4>
                    <p className="mt-2">{t("settings.from")}: {fixDate(data?.period?.from, true)}</p>
                    <p className="">{t("settings.to")}: {fixDate(data?.period?.to, true)}</p>
                    <p className="">{t("settings.format")}: {data?.format}</p>
                    <p className="mt-2 thin">{t("settings.export_created")}: {fixDate(data?.created, true)}</p>

                </div>
            </div>
            <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
               <Button onClick={() => handleClose()} btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
               <Button onClick={() => download(data.downloadtoken)} btnClass="btn-primary">{t("settings.download")}</Button>
            </div>
            </>
        )
    }



    const typeRender = () => {
        switch (type.type){
            case "generate":
                return generateContent()
            case "download":
                return downloadContent()
            default: return null
        }
        
        
    }


return(
    <>
    <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
        <Card className="settings-dialog d-flex flex-column">
            <div className="w-100 h-100">
                {typeRender()}
            </div>
        </Card>
    </Dialog>
    </>
)
}

export default ExportDataModal;